import { createIconDefinition } from '../../../../cross-team-shared/icons/create-icon-definition';

export const addFeedbackIcon = createIconDefinition(
  'addFeedback',
  `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 1V4H13.5V6H16.5V9H18.5V6H21.5V4H18.5V1H16.5ZM3.5 4H11.5V6H5.5V12H12.74L13.14 14H16.5V11H18.5V16H11.5L11.1 14H5.5V21H3.5V4Z" fill="#232426" fill-opacity="0.87"/>
    </svg>`,
);
